// extracted by mini-css-extract-plugin
export default {"tooltip":"styles_tooltip__OviWT","modal":"styles_modal__hcd1W"};